import { useCallback, useMemo, useState } from "react"
import {
  FilterState,
  OrderStatusEnum,
  SortOrderType,
} from "src/features/shared-module/constants"

export const useOrderFilter = () => {
  const [filterState, setState] = useState<FilterState>({
    haulerIds: [],
    haulerEmployeeIds: [],
    query: null,
    sortBy: "",
    sortOrder: "asc",
    stateList: [],
  })

  const setFilterQuery = useCallback(
    (payload: string | null) =>
      setState((prev) => ({ ...prev, query: payload })),
    [],
  )

  const setHaulerEmployeeIds = useCallback(
    (payload: number[]) =>
      setState((prev) => ({ ...prev, haulerEmployeeIds: payload })),
    [],
  )

  const setHaulerIds = useCallback(
    (payload: number[]) =>
      setState((prev) => ({ ...prev, haulerIds: payload })),
    [],
  )

  const setOrderStateList = useCallback(
    (payload: OrderStatusEnum[]) =>
      setState((prev) => ({ ...prev, stateList: payload })),
    [],
  )

  const setSorting = useCallback(
    ({ sortBy, sortOrder }: { sortBy: string; sortOrder: SortOrderType }) =>
      setState((prev) => ({
        ...prev,
        sortBy,
        sortOrder,
      })),
    [],
  )

  const actions = useMemo(
    () => ({
      setFilterQuery: setFilterQuery,
      setSorting,
      setHaulerEmployeeIds,
      setHaulerIds,
      setOrderStateList,
    }),
    [
      setFilterQuery,
      setHaulerEmployeeIds,
      setHaulerIds,
      setOrderStateList,
      setSorting,
    ],
  )

  return { filterState, actions }
}
